import { TIChartPointModel } from "../../models/data-point/ti-chart-point.model";
import { TIIndicatorDataModel } from "../../models/data-point/ti-indicator-data.model";

export class JSApiPointToTiIndicatorPointMapper {
    public static map(rawData: Array<TIChartPointModel>, color: string): TIIndicatorDataModel {
        
        //TODO: Right now this class is just for Volume, but if we add more WebChart indicators we'll want to 
        // separate out the below logic to be volume specific 
        for (const point of rawData) {
            point.color = point.isUpBar() ? '#008000' : '#ff0000';
        }

        const indicatorDataModel = new TIIndicatorDataModel({
            name: 'VOLUME',
            abbreviatedName: 'VOLUME',
            chartAreaName: 'ChartArea-2',
            colorType: 1,
            points: rawData
        });

        return indicatorDataModel;
    }
}